export * from "./copy-template-to-subscriber.component";
